module.exports = __webpack_public_path__ + "static/img/p2b-1.20230dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/p2b-1.jpg
// module id = 8570
// module chunks = 1